import $ from 'jquery';
import classnames from 'consts/classnames';

/**
 * * @returns {void}
 */
const hideHelloBar = () => {
    const { IS_HIDDEN } = classnames;

    const closeButtons = document.querySelectorAll('.js-hello-bar-close');

    if (!closeButtons.length) {
        return;
    }

    addClickEventToCloseButtons();

    /**
     * @param {MouseEvent} event
     * * @returns {void}
     */
    function clickHandler(event) {
        const { currentTarget } = event;
        const container = currentTarget.closest('.js-hello-bar');

        if (!container) {
            return;
        }

        container.classList.add(IS_HIDDEN);
    }

    /**
     * * @returns {void}
     */
    function addClickEventToCloseButtons() {
        closeButtons.forEach(button => {
            // we will attach new button listeners once the HTML is updated via Update Panel
            button.removeEventListener('click', clickHandler);
            button.addEventListener('click', clickHandler);
        });
    }
};

$(() => {
    hideHelloBar();
});
